/**
 * PluginCard component for displaying plugins in a grid
 */

import React from "react";
import type { PluginCardProps } from "../types/index";

export default function PluginCard({ plugin, onClick }: PluginCardProps): JSX.Element {
  return (
    <div
      onClick={onClick}
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "1rem",
        backgroundColor: "white",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        cursor: onClick ? "pointer" : "default",
        transition: "box-shadow 0.2s, transform 0.2s",
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          (e.currentTarget as HTMLElement).style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
          (e.currentTarget as HTMLElement).style.transform = "translateY(-2px)";
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          (e.currentTarget as HTMLElement).style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
          (e.currentTarget as HTMLElement).style.transform = "translateY(0)";
        }
      }}
    >
      <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.1rem", color: "#0078d4" }}>
        {plugin.pluginName}
      </h3>

      <p style={{ margin: "0 0 0.5rem 0", color: "#666", fontSize: "0.9rem" }}>
        {plugin.orgOrOwner}/{plugin.repoName}
      </p>

      <p style={{ margin: "0 0 0.75rem 0", color: "#444", lineHeight: "1.4" }}>
        {plugin.description || "No description available"}
      </p>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        <span style={{ fontSize: "0.85rem", backgroundColor: "#e6f0ff", color: "#0078d4", padding: "0.25rem 0.5rem", borderRadius: "4px" }}>
          v{plugin.version}
        </span>
      </div>

      {plugin.author && (
        <p style={{ margin: "0.5rem 0 0 0", color: "#999", fontSize: "0.85rem" }}>
          By {plugin.author}
        </p>
      )}

      {plugin.keywords && plugin.keywords.length > 0 && (
        <div style={{ marginTop: "0.5rem" }}>
          {plugin.keywords.slice(0, 3).map((keyword: string) => (
            <span
              key={keyword}
              style={{
                display: "inline-block",
                backgroundColor: "#f0f0f0",
                color: "#555",
                padding: "0.25rem 0.5rem",
                borderRadius: "4px",
                marginRight: "0.25rem",
                marginBottom: "0.25rem",
                fontSize: "0.85rem",
              }}
            >
              {keyword}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
